import { AuthService } from "@/services";
import { mapActions } from "vuex";
import * as types from "@/store/types";
import debounce from "lodash-es/debounce";
import RegisterBanner from "@/components/Auth/Register/registerBanner.vue";
import initService from "@/services/modules/initService";
const Captcha = () =>
  import(/* webpackChunkName: "Captcha" */ "@/components/Captcha/index");
export default {
  name: "register",
  components: { Captcha, RegisterBanner },
  props: [],
  data() {
    return {
      checkbox: "",
      loading: false,
      emailOrMobile: "",
      password: "",
      passwordValidation: [
        () =>
          !!this.password ||
          this.$t("authPage.registerPage.password.validation.notEmpty"),
        v =>
          !/^[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF]+$/.test(
            v.replace(/\s/g, "")
          ) || this.$t("authPage.registerPage.password.validation.notPersian")
      ],
      passwordConfirmation: "",
      referralCode: null,
      policyChecked: false,
      show1: false,
      show2: false,
      validationRegex: [],
      matchedCase: [],
      validationMessage: "",
      regexErrors: [],
      isFocused: false,
      isBlurred: false,
      termConfirmation: false,
      captcha_token: null,
      captcha_value: null,
      captcha_hash: null,
      reloadCaptcha: false,
      showPanel: "",
      disablePanel: false,
      publicUrl: process.env.VUE_APP_PUBLIC_BASE_URL,
      captchaStatus: false
    };
  },
  mounted() {
    this.getPasswordRegex();
    if (this.$route.query.refCode || this.$route.query.referral_code) {
      this.referralCode =
        this.$route.query.refCode || this.$route.query.referral_code;
      this.showPanel = 0;
      this.disablePanel = true;
    }
    this.getCaptchaStatus()
  },
  methods: {
    ...mapActions({
      checkIsAuth: types.auth.actions.ACTION_CHECK_IS_AUTH,
      setValidationRegex: types.auth.actions.ACTION_VALIDATION_REGEX
    }),
    getCaptchaStatus() {
      initService.initSecurity().then(res => {
        this.captchaStatus = res.data.data.captcha.users_sign_up
      })
    },
    captchaChanged(captchaData) {
      this.captcha_token = captchaData.token;
      this.captcha_value = captchaData.value;
    },
    onSubmit: debounce(function() {
      this.$refs.form.validate();
      this.loading = true;
      this.registerUser();
    }, 500),
    registerUser() {
      AuthService.signUp(
        this.emailOrMobile,
        this.password,
        this.passwordConfirmation,
        this.termConfirmation,
        this.referralCode,
        this.captcha_token,
        this.captcha_value
      )
        .then(response => {
          localStorage.setItem("otpToken", response.data.data.otp_token);
          localStorage.setItem("emailOrMobile", this.emailOrMobile);
          localStorage.setItem("ttl", response.data.data.ttl);
          this.$router.push("/auth/register/register-verification");
        })
        .catch(error => {
          this.captcha_token = null;
          this.captcha_value = null;
          this.captcha_hash = error.data.captcha_hash;
        })
        .finally(() => {
          this.loading = false;
          this.reloadCaptcha = !this.reloadCaptcha;
        });
    },
    getPasswordRegex() {
      AuthService.passwordRegex()
        .then(response => {
          this.validationRegex = response.data.data;
        })
        .then(() => {
          this.validationRegex.forEach(elem => {
            let regex = elem.regex;
            regex = regex.substring(1, regex.length - 1);
            this.matchedCase.push({
              message: elem.message,
              type: elem.type,
              regex: regex,
              status: "default"
            });
          });
        });
    },
    validatePassword(value) {
      this.regexErrors = [];
      this.matchedCase.forEach(elem => {
        if (value.match(elem.regex)) {
          if (this.isFocused) {
            elem.status = "checked";
          }
          this.regexErrors.push(elem);
        } else {
          if (this.isBlurred) {
            elem.status = "unchecked";
          } else if (this.isFocused) {
            elem.status = "default";
          }
          this.regexErrors.push(elem);
        }
      });
    },
    reInitValidation(event) {
      if (event.type === "focus") {
        this.isFocused = true;
        this.regexErrors = [...this.matchedCase];
      } else if (event.type === "blur") {
        this.isBlurred = true;
        this.validatePassword(this.password);
      }
    }
  }
};
